<button
  (click)="clicked($event)"
  aria-label="Zoeken"
  class="search-trigger--button"
  wlAutomationId="search-trigger"
  #buttonEl
>
  <fa-icon [size]="size()" class="fa-icon" icon="search" />
</button>
